module.exports = __webpack_public_path__ + "img/logo-white-ofis.548fe3b1.png";